import { createAction } from 'typesafe-actions';

export const pollBackgroundFanGuidanceExtension = createAction(
    'POLL/BACKGROUND_FAN_GUIDANCE_EXTENSION',
    (resolve)=>{
        return (payload: {grain_bin_id: number | null})=>resolve(payload);
    }
)